import URLConfig from '@Config/urls/url.config';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import ListOfBrokenRulesDataTableCardHandler from '@Modules/fraudManagement/containers/dataTableHandlers/emitter/listOfCardsByBrokenRule/ListOfCardsByBrokenRuleDataTableHandler';
import { FaArrowLeft } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';

const ListOfCardsByBrokenRulePage = () => {
    const bg = CC.useColorModeValue('gray.400', 'whiteAlpha.700');

    const { idRule } = useParams();

  return (
    <>
        {/* Back to previous page Section */}
        <CC.HStack>
            <Link
            to={
                URLConfig.FRAUD_MANAGEMENT.EMITTER_MENU.LIST_OF_BROKEN_RULES
            }
            >
            <CC.Box
                borderRadius={'50%'}
                p={'0.5rem'}
                _hover={{ backgroundColor: `${bg}` }}
            >
                <FaArrowLeft size={'1.5rem'} />
            </CC.Box>
            </Link>

            <CC.Hide below="md">
            <CC.Heading size="lg">Liste Règles Transgressées</CC.Heading>
            </CC.Hide>

            <CC.Show below="md">
                <CC.Heading size="lg">Retour</CC.Heading>
            </CC.Show>
        </CC.HStack>

        <CC.Divider my={'2rem'} />
        
        <CC.Heading size="md" ml={8} mb={8}>Cartes Par Règle</CC.Heading>

        <ListOfBrokenRulesDataTableCardHandler  idRule ={ idRule  || ''} />
    </>
  )
}

export default ListOfCardsByBrokenRulePage